<template>
  <div>
  <v-list-tile v-if="list" @click.capture.stop="handleDelete">
    <v-list-tile-action>
      <v-icon color="primary" class="theme--light">delete</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      {{ $t('message.entity.actions.delete') }}
    </v-list-tile-content>
  </v-list-tile>
  <v-tooltip top v-else>
    <template #activator="{on}">
      <v-btn v-on="on" class="ma-0" icon @click.capture.stop="handleDelete">
        <v-icon color="primary" class="theme--light">delete</v-icon>
      </v-btn>
    </template>
    <strong v-html="$t('message.entity.actions.delete')"></strong>
  </v-tooltip>
  <nx-dialog-confirm disable-automatic-dismiss
                     :text="$t('message.entity.actions.deleteConfirmText')"
                     :title="$t('message.entity.actions.deleteConfirmTitle')"
                     :accept-text="$t('message.common.delete')"
                     accept-color="error"
                     cancel-color="primary"
                     ref="confirm" />
    </div>
</template>

<script>
import toast from '@/modules/toast/services';
import apiFactory from '@/modules/entity/api';
import NxDialogConfirm from '@/components/dialogs/Confirm.vue';

export default {
  name: 'nx-list-action-delete-entity',
  components: {
    NxDialogConfirm,
  },
  props: {
    entity: {
      type: String,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    list: {
      type: Boolean,
    },
  },

  methods: {
    async handleDelete() {
      const agree = await this.$refs.confirm.open();
      if (!agree) {
        return;
      }
      const api = apiFactory(this.entity);
      try {
        await api.remove(this.entityId);
        toast.notify('message.entity.actions.deletedSuccess');
        this.$emit('delete', { id: this.entityId, type: this.entity });
      } catch (error) {
        toast.notify('message.content.tools.deletedFail');
        console.error(error);
      } finally {
        this.$refs.confirm.dismiss();
      }
    },
  },
};
</script>
